import * as ko from "knockout";
import Bao from "../../../services/bao-service";
import SubscriptionViewModel from "../../../factories/subscription-view-model";
import RoleShiftbookTabDialog from "./role-shiftbook-tab-dialog";
/*
 * ViewModel for RoleShiftbookTab Tab
 * */
class RoleShiftbookTabDialogShiftbookTab extends SubscriptionViewModel {
    RoleShiftbookTabDialog: RoleShiftbookTabDialog = null;
    RoleShiftbookShiftbookTabId: KnockoutObservable<string>;
    ShiftbookTabTypeKey: KnockoutObservable<string>;
    ShiftbookTabId: KnockoutObservable<string>;
    Permissions: KnockoutObservableArray<any> = ko.observableArray([]);

    constructor(tabPage: Factories.TabPage, parent: any) {
        super(tabPage);
        this.RoleShiftbookTabDialog = parent.ViewModel();
    }

    init() {
        return this.LoadData();
    }

    loaded() {
        this.TabPage.IsLoading(false);
    }

    /*
     * Gets and sets the model for the model view
     * */
    LoadData() {
        this.TabPage.IsLoading(true);
        const tabs = this.RoleShiftbookTabDialog.TabModels().filter(x => x.ShiftbookTabId === this.TabPage.ObjectId());
        let tab = null;
        if (tabs) {
            tab = tabs[0];
        }

        if (tab) {
            this.Permissions(tab.Permissions);
        }

        return Bao.post("RoleShiftbookTab/GetItemRoleShiftbookTab", JSON.stringify({
            parentId: this.RoleShiftbookTabDialog.RoleShiftbookId(),
            sessionTabId: this.RoleShiftbookTabDialog.Parent.SessionTabId,
            shiftbookTabTypeKey: tab?.ShiftookTabTypeKey,
            shiftbookTabId: this.TabPage.ObjectId()
        })).then(result => {
            ko.map.fromJS(result, this);
            if (!this.ShiftbookTabId()) {
                this.ShiftbookTabId(this.TabPage.ObjectId());
            }
        }).always(_ => this.TabPage.IsLoading(false));
    }

    GetModelToSave(): JQueryPromise<any> {
        throw new Error("Method not implemented.");
    }

    IsSelected(item) {
        return ko.computed({
            read: function () {
                return ko.unwrap(this[item.Permission]);
            },
            write: function (newValue) {
                this[item.Permission](newValue);
            }
        }, this);
    }
}
export default RoleShiftbookTabDialogShiftbookTab;